import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
    this.handleBeforeCache = this.handleBeforeCache.bind(this)

    document.addEventListener("click", this.handleDocumentClick)
    document.addEventListener("keydown", this.handleEscape)
    document.addEventListener("turbo:before-cache", this.handleBeforeCache)

    this.close()
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
    document.removeEventListener("keydown", this.handleEscape)
    document.removeEventListener("turbo:before-cache", this.handleBeforeCache)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.opened()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("hidden")
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }

  handleDocumentClick(event) {
    if (!this.opened()) return
    if (this.element.contains(event.target)) return

    this.close()
  }

  handleEscape(event) {
    if (event.key !== "Escape") return

    this.close()
  }

  handleBeforeCache() {
    this.close()
  }

  opened() {
    return this.hasPanelTarget && !this.panelTarget.classList.contains("hidden")
  }
}
